import object from '@mailobj-browser/front/js/utils/object.js'

const block = 'ea_space'

export const elements = object(null, {
  registrar_available: `${block}__registrar_search_available`,
  registrar_unavailable: `${block}__registrar_search_unavailable`,
  registrar_search_list: `${block}__registrar_search_list`,
  form_registrar_results: `${block}__form_registrar_results`,
  form_registrar_results_footer: `${block}__form_registrar_results_footer`,
  form_registrar_results_button_submit: `${block}__form_registrar_results_button_submit`,
  fridge_container: `${block}__fridge_container`,
  fridge_magnet: `${block}__fridge_magnet`,
  fridge_memo: `${block}__fridge_memo`,
  fridge_new: `${block}__fridge_new`,
})

export const modifiers = object(null, {
  form_registrar_results_footer_background: object(null, {
    show: `${elements.form_registrar_results_footer_background}-show`
  }),
  fridge_memo: object(null, {
    focus: `${elements.fridge_memo}-focus`
  }),
})
